import React, { Component } from "react";
import {getFavoriteAuthor,removeFavoriteAuthor,addFavoriteAuthor,authorslist_all} from '../config/Variables';
export default class FetchOwnUserPopup extends Component {

  constructor() {
    super();
    this.state = {
      hobbies: [],
      tid: '',
      messagelog: '',
      isLoading: true,
      users: [],
      numberstid: [],
      error: null
    }
    this.handleInputChangeUser = this.handleInputChangeUser.bind(this);
    this.RemovetidUser = this.RemovetidUser.bind(this);

  }
  componentWillMount() {
   

  }
  handleInputChangeUser(event) {
    const target = event.target;
    var value = target.value;

    if (target.checked) {
      this.state.hobbies.push(value);
      // this.setState({messagelog:"اختر الكاتب المفضل لديك"});
    } else {

      // this.state.hobbies= this.state.hobbies.filter(a => a !== value);

      const index = this.state.hobbies.indexOf(value);

      if (index > -1) {
        this.state.hobbies.splice(index, 1);

        this.state.hobbies.splice(index, 1)
        const x = this.state.hobbies.indexOf(value);

        if (this.state.hobbies.indexOf(value) > -1) {
          this.state.hobbies.splice(index, 1);
        } // 2nd parameter means remove one item only
      }




      // this.state.hobbies.splice(value, 1);
    }
  }

  async RemovetidUser(event) {

    const target = event.target;
    var value = target.value;

    if (event.target.checked) {
      this.state.hobbies.push(value);
      // this.setState({messagelog:"اختر الكاتب المفضل لديك"});
    } else {
      console.log("iam herererer");
      const index = (this.state.hobbies).indexOf(parseInt(value, 2));


      for (var i = 0; i < this.state.hobbies.length; i++) {

        if (this.state.hobbies[i] == value) {
          this.state.hobbies.splice(i, 1);
        }

      }
    }
  }


  async submituser() {
    const tid = this.state.hobbies.join(',');
    const isList=true;
    console.log(tid);
    let item = { tid,isList };
    if (tid == "") {
      window.location.reload(false);
    } else {
      if (localStorage.getItem('user-info')) {

        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(addFavoriteAuthor, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();

        if (result.message.code == '200') {
          //localStorage.setItem("user-info", JSON.stringify(result));
          //history('/add');
          //this.props.fetchownusercallback("selectauthorpopup");
          this.props.fetchownusercallback(this.state.hobbies);

        }
      }
    }
  // window.location.reload(false);
  }
  getFetchUserspopup() {
    var numberstid_constant=[];
    var numberstid_hobbies=[];
    let user = JSON.parse(localStorage.getItem('user-info'))
    let datt = fetch(getFavoriteAuthor, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json',
        "Authorization": "Bearer " + user.token.access_token,
      },
      body: JSON.stringify(this.state)
    }).then(response => response.json())
      .then(data => {
        data.data.map(({ tid }, index2) => {
          this.state.numberstid.push(tid);
          numberstid_constant.push(tid);
          numberstid_hobbies.push(tid);
        });
    


    this.setState({
      loading: true
    }, () => {
      fetch(authorslist_all).then(res => res.json()).then(result => this.setState({
        loading: false,
        users: result.rows,
        numberstid: numberstid_constant,
          hobbies:numberstid_hobbies
      })).catch(console.log);
    });
  });
  }
  componentDidMount() {
    this.getFetchUserspopup();
  }

  render() {
    const {
      users,
      error
    } = this.state;
    var xxx=this.props.userslist;
    return (

      <div className="modal-wrap" data-modal="modal-author-checked" id="authorCheckedModal">
        <div className="modal-overlay modal-toggle"></div>
        <div className="modal-wrapper modal-transition">
          <div className="modal-before">
            <button className="modal-close">
              <span aria-hidden="true">&times;</span>
            </button>
            <button onClick={() => this.submituser()} className="button modal-close primary-light rounded select-all"><i className="icomoon-icon icon-check-green"></i><span aria-hidden="true"> تم</span> </button>
          </div>
          <div className="modal-inner">
            <div className="topper-title text-center margin-bottom-3">
              <h3>مواضيعي المفضله</h3>
              <p>اختر كتابك المفضلين لتحصل علي افضل تجربة </p>
            </div>

            <div className="vertical-scroll-wrapper">
              <div className="vertical-scroll-inner v-scroller_js">
                <div className="authors-list v-inner-scroll">
                  <React.Fragment>
                    {
                      xxx.map(({ name, tid, field_opinion_writer_photo }, index) => {
                      /*  const fruitss = this.state.numberstid.filter(
                                      item => this.props.pUsers.includes(item)==false
                                    );

                        const ttt = parseInt(tid);

                        const ss = fruitss.includes(ttt) && !this.props.pUsers.includes(tid); //true

                        */

                        const fruitss = this.state.numberstid;
                        const ttt = parseInt(tid);
                        const ss = fruitss.includes(ttt); //true
                        if (ss) {
                          return (
                            <div className="author-option" key={index}>
                              <label for={`custom-user-checkbox-${index}`} className="multi-check">
                                <input type="checkbox" id={`custom-user-checkbox-${index}`}
                                  name="hobbiesuser" defaultChecked={true} defaultValue={`${tid}`}
                                  className="form-check" onTouchEnd={this.RemovetidUser} onClick={this.RemovetidUser} />
                                <div className="author-img round">
                                  <img src={field_opinion_writer_photo} alt="author" />
                                </div>
                                <div className="author-meta">
                                  <div className="author-name">{name}</div>

                                </div>
                              </label>
                            </div>
                          );
                        } else {
                        }
                      })
                    }
                  </React.Fragment>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    );
  }
}
